import { render } from "./ContactCompo.vue?vue&type=template&id=8213362c&scoped=true"
import script from "./ContactCompo.vue?vue&type=script&lang=js"
export * from "./ContactCompo.vue?vue&type=script&lang=js"

import "./ContactCompo.vue?vue&type=style&index=0&id=8213362c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8213362c"]])

export default __exports__